module.exports = __webpack_public_path__ + "static/media/patient-record.93483284.png";